import React from 'react';
import PropTypes from 'prop-types';
import cn from 'classnames';
import { compose } from 'recompose';
import { isInvalid, formValueSelector } from 'redux-form';
import { connect } from 'react-redux';

import { fetchLocationData } from 'redux-modules/location';

const ProgressIndicator = ({
  steps,
  currentStep,
  handleClick,
  isFormInvalid,
  fetchLocationIfNeeded,
}) => {
  const classname = step => cn(
    'progress-indicator__step',
    { 'progress-indicator__step--active': currentStep === step },
    { 'progress-indicator__step--passed': currentStep > step },
  );
  return (
    <div className="progress-indicator">
      {steps.map(step => (
        <button
          key={step.id}
          className={classname(step.id)}
          onClick={() => { handleClick(step.id)(); fetchLocationIfNeeded(); }}
          disabled={currentStep === step.id || isFormInvalid || step.id - currentStep > 1}
          type="button"
        >
          {step.icon({ className: 'progress-indicator__icon' })}
          <span className="progress-indicator__label">{step.title}</span>
        </button>
      ))}
    </div>
  );
};

ProgressIndicator.propTypes = {
  steps: PropTypes.arrayOf(PropTypes.shape({
    title: PropTypes.string.isRequired,
    id: PropTypes.number.isRequired,
  })).isRequired,
  currentStep: PropTypes.number.isRequired,
  handleClick: PropTypes.func.isRequired,
  isFormInvalid: PropTypes.bool.isRequired,
  fetchLocationIfNeeded: PropTypes.func.isRequired,
};

const enhance = compose(
  connect(
    (state, { formName }) => ({
      state,
      isFormInvalid: isInvalid(formName)(state),
    }),
    dispatch => ({ dispatch }),
    ({ state, ...stateProps }, { dispatch, ...dispatchProps }, { formName, ...ownProps }) => ({
      ...stateProps,
      ...dispatchProps,
      ...ownProps,
      fetchLocationIfNeeded: () => {
        const zipCode = formValueSelector(formName)(state, 'Zip Code');
        return zipCode && dispatch(fetchLocationData(zipCode));
      },
    }),
  ),
);

export default enhance(ProgressIndicator);



// WEBPACK FOOTER //
// ./src/components/ProgressIndicator.js